import customHeaders, { getSpace } from '../../../common/headers';
import { ButtonClose, InputDinamycPlaceholder, DropDownSelector, ButtonBasic, CheckboxToggle } from '@lk-gtcom/ecomlab-components'
import { DateBox } from '../../../components/DateBox/DateBox';
import { DynamicFormComponent } from '../../../components/DynamicFormComponent/DynamicFormComponent';
import { fetchApiFilterVer3 } from '../../../common/filtersFunc';
import { TitlePage } from '../../../components/TitlePage/TitlePage'
import { StepItem } from '../../../components/StepItem/StepItem';
import { useResponseHandler } from '../../../common/auth'
import useGeneralStore from '../../../store/general';
import { useEffect, useState } from 'react';
import { MoonLoader } from 'react-spinners';
import dayjs from 'dayjs';
import { DecisionSelector } from './DecisionSelector/DecisionSelector';
import "./ModalReturnsRule.scss"

export const options_prop_mp = [
    { label: 'Wildberries', value: 3 },
    { label: 'Yandex', value: 2 },
];

// Компонент для отдельного условия
const ConditionItem = ({
    condition,
    index,
    currentConditions,
    selectedApi,
    onConditionChange,
    onRemove,
    canRemove
}) => {
    const [conditionType, setConditionType] = useState(condition?.condition_type || '');
    const [conditionName, setConditionName] = useState(condition?.name || '');
    const [conditionFields, setConditionFields] = useState(condition?.attributes || []);

    const selectedCondition = currentConditions?.find(c => c?.condition_type === conditionType) || null;

    const handleConditionTypeChange = (selected) => {
        if (selected && selected?.condition_type) {
            setConditionType(selected?.condition_type);
            setConditionName(selected?.name || '');
            const existingAttributes = condition?.attributes || [];
            const newAttributes = selected?.attributes?.map(attr => {
                const existingAttr = existingAttributes.find(e => e?.attribute_id === attr?.attribute_id);
                return {
                    ...attr,
                    value: existingAttr?.value || attr?.value || null
                };
            }) || [];
            setConditionFields(newAttributes);
        } else {
            setConditionType('');
            setConditionName('');
            setConditionFields([]);
        }
    };

    useEffect(() => {
        if (conditionType) {
            onConditionChange(index, {
                condition_type: conditionType,
                name: conditionName,
                attributes: conditionFields
            });
        }
    }, [conditionType, conditionName, conditionFields, index]);

    useEffect(() => {
        if (conditionType && currentConditions?.length > 0) {
            const found = currentConditions.find(c => c?.condition_type === conditionType);
            if (found) {
                setConditionName(found?.name || '');
                const existingAttributes = condition?.attributes || [];
                const newAttributes = found?.attributes?.map(attr => {
                    const existingAttr = existingAttributes.find(e => e?.attribute_id === attr?.attribute_id);
                    return {
                        ...attr,
                        value: existingAttr?.value || attr?.value || null
                    };
                }) || [];
                setConditionFields(newAttributes);
            }
        }
    }, [currentConditions, conditionType]);

    return (
        <div className='modal-returns-rule__content-item'>
            <div className='modal-returns-rule__condition-header'>
                <TitlePage
                    medium
                    title={`Условие ${index + 1}`}
                />
                {canRemove && (
                    <ButtonClose
                        onClick={() => onRemove(index)}
                        s
                    />
                )}
            </div>

            <DropDownSelector
                state={selectedCondition}
                options_prop={currentConditions || []}
                setState={handleConditionTypeChange}
                placeholder="Выберите тип условия"
                maxWidth='432px'
                required
            />

            {conditionType && conditionFields && (
                <DynamicFormComponent
                    api_id={selectedApi?.map(el => el?.value) || []}
                    productTemporary={conditionFields}
                    setProductTemporary={setConditionFields}
                />
            )}
        </div>
    );
};

const ModalReturnsRule = ({
    currentRule,
    setCurrentRule,
    setIsModal
}) => {
    const selectedSpace = useGeneralStore((state) => state.selectedSpace);
    const headers = { ...customHeaders, ...getSpace(selectedSpace) };

    const { handleStatusCode, handleTableResponse, handleRequestError } = useResponseHandler();
    const [loading, setLoading] = useState(false)

    const [name, setName] = useState(currentRule?.name || '')
    const [date, setDate] = useState(currentRule?.start_at ? new Date(currentRule?.start_at) : new Date())
    const [isActive, setIsActive] = useState(currentRule?.enabled || false)

    const [apiPage, setApiPage] = useState(1);
    const [apiQuery, setApiQuery] = useState('');
    const [apiData, setApiData] = useState([]);
    const [totalApi, setTotalApi] = useState(0);

    const [selectedMarketplace, setSelectedMarketplace] = useState(
        options_prop_mp?.filter((el) => el?.value == currentRule?.mp_id)?.[0] || null
    );

    const [selectedApi, setSelectedApi] = useState(() => {
        if (currentRule?.api_ids) {
            if (Array.isArray(currentRule.api_ids) && currentRule.api_ids[0]?.label) {
                return currentRule.api_ids;
            }
            return currentRule.api_ids.map(id => ({
                label: String(id),
                value: id
            }));
        }
        return [];
    });

    const initConditions = () => {
        if (currentRule?.conditions && currentRule?.conditions.length > 0) {
            return currentRule.conditions.map(el => ({
                ...el,
                label: el?.name,
                value: el?.condition_type
            }));
        }
        return [{ condition_type: '', name: '', attributes: [] }];
    };

    const [conditions, setConditions] = useState(initConditions);
    
    const [selectedDecision, setSelectedDecision] = useState(() => {
        if (currentRule?.decision_template?.code) {
            return {
                value: currentRule.decision_template.code,
                code_label: currentRule.decision_template.code_label,
                label: currentRule.decision_template.code_label
            };
        }
        return [];
    });

    const [decisionData, setDecisionData] = useState(() => {
        if (currentRule?.decision_template) {
            return {
                comment: currentRule.decision_template.comment || '',
                reason: currentRule.decision_template.reason || '',
                compensation: currentRule.decision_template.compensation || null,
                selectedReason: currentRule.decision_template.reason ? {
                    value: currentRule.decision_template.reason,
                    label: currentRule.decision_template.reason
                } : null
            };
        }
        return null;
    });

    // Поля для окна активации
    const [mainFields, setMainFields] = useState(() => {
        if (currentRule?.activation_window?.attributes) {
            return currentRule.activation_window.attributes;
        }
        return [];
    });

    // Чекбокс для показа/скрытия окна активации - по умолчанию false
    const [showActivationWindow, setShowActivationWindow] = useState(() => {
        // Если есть currentRule и у него есть заполненные атрибуты, показываем
        if (currentRule?.activation_window?.attributes && currentRule.activation_window.attributes.length > 0) {
            const hasFilledValues = currentRule.activation_window.attributes.some(field => 
                field?.value !== null && field?.value !== undefined && field?.value !== ''
            );
            return hasFilledValues;
        }
        return false;
    });

    const [currentConditions, setCurrentConditions] = useState([])
    const [conditionsLoading, setConditionsLoading] = useState(true)

    const apiFilter = () => {
        fetchApiFilterVer3({
            selectedSpace: selectedSpace?.value,
            page: apiPage,
            setApiData: setApiData,
            set: setApiData,
            searchParam: apiQuery,
            selectedApi,
            selectedShop: selectedMarketplace,
            filter: 'api_id',
            setTotal: setTotalApi
        });
    };

    useEffect(() => {
        apiFilter()
    }, [apiPage, apiQuery]);

    const fetchGetConditions = (abortController = new AbortController()) => {
        setConditionsLoading(true);
        let url = `https://apps2.ecomru.ru:4655/v1/return-rules/conditions`;

        fetch(url, { headers, signal: abortController.signal })
            .then(handleTableResponse)
            .then((json) => {
                const formattedConditions = json.map(el => ({
                    ...el,
                    label: el?.name,
                    value: el?.condition_type
                }));
                setCurrentConditions(formattedConditions);

                if (currentRule?.conditions) {
                    const updatedConditions = currentRule.conditions.map(ruleCond => {
                        const found = formattedConditions.find(c => c?.condition_type === ruleCond?.condition_type);
                        return {
                            ...ruleCond,
                            label: found?.name || ruleCond?.name,
                            value: ruleCond?.condition_type
                        };
                    });
                    setConditions(updatedConditions);
                }
            })
            .catch(handleRequestError)
            .finally(() => {
                setConditionsLoading(false);
                if (abortController.signal.aborted) return
            })
    };

    const fetchGetActivationWindow = (abortController = new AbortController()) => {
        let url = `https://apps2.ecomru.ru:4655/v1/return-rules/activation-window`;

        fetch(url, { headers, signal: abortController.signal })
            .then(handleTableResponse)
            .then((json) => {
                const existingAttributes = mainFields || [];
                const newAttributes = json?.attributes?.map(attr => {
                    const existingAttr = existingAttributes.find(e => e?.attribute_id === attr?.attribute_id);
                    return {
                        ...attr,
                        value: existingAttr?.value || attr?.value || null
                    };
                }) || [];
                setMainFields(newAttributes);
                
                // Если есть currentRule с заполненными атрибутами, показываем чекбокс
                if (currentRule?.activation_window?.attributes) {
                    const hasFilledValues = currentRule.activation_window.attributes.some(field => 
                        field?.value !== null && field?.value !== undefined && field?.value !== ''
                    );
                    if (hasFilledValues) {
                        setShowActivationWindow(true);
                    }
                }
            })
            .catch(handleRequestError)
            .finally(() => {
                if (abortController.signal.aborted) return
            })
    };

    useEffect(() => {
        if (!currentRule) {
            fetchGetActivationWindow()
        }
    }, [currentRule]);

    useEffect(() => {
        fetchGetConditions()
    }, []);

    const handleConditionChange = (index, updatedCondition) => {
        setConditions(prev => {
            const newConditions = [...prev];
            newConditions[index] = updatedCondition;
            return newConditions;
        });
    };

    const handleAddCondition = () => {
        setConditions(prev => [
            ...prev,
            { condition_type: '', name: '', attributes: [] }
        ]);
    };

    const handleRemoveCondition = (index) => {
        if (conditions.length > 1) {
            setConditions(prev => prev.filter((_, i) => i !== index));
        }
    };

    const handleDecisionChange = (data) => {
        setDecisionData(data);
    };

    const buildRequestBody = () => {
        const validConditions = conditions.filter(
            cond => cond?.condition_type && cond?.condition_type !== ''
        );

        const decisionTemplate = {
            "code": selectedDecision?.value || "approve_with_examination",
            "code_label": selectedDecision?.code_label || selectedDecision?.label || "Одобрить возврат с проверкой товара",
            "comment": decisionData?.comment || "",
            "reason": decisionData?.selectedReason?.value || decisionData?.reason || "",
            "require_confirmation": true
        };

        if (decisionData?.compensation) {
            decisionTemplate.compensation = decisionData.compensation;
        }

        // Формируем activation_window: если чекбокс не активен или поля пустые, отправляем null
        let activationWindow = null;
        if (showActivationWindow && mainFields && mainFields.length > 0) {
            const hasFilledFields = mainFields.some(field => 
                field?.value !== null && field?.value !== undefined && field?.value !== ''
            );
            if (hasFilledFields) {
                activationWindow = {
                    attributes: mainFields
                };
            }
        }

        const requestBody = {
            name,
            mp_id: selectedMarketplace?.value,
            api_ids: selectedApi,
            enabled: isActive,
            start_at: date,
            activation_window: activationWindow,
            conditions: validConditions.map(cond => ({
                condition_type: cond.condition_type,
                name: cond.name || 'Unnamed condition',
                attributes: cond.attributes || []
            })),
            decision_template: decisionTemplate
        };

        console.log('Request body:', JSON.stringify(requestBody, null, 2));
        return requestBody;
    };

    const fetchCreateRule = (abortController = new AbortController()) => {
        setLoading(true);
        const url = `https://apps2.ecomru.ru:4655/v1/return-rules${currentRule ? `/${currentRule?.id}` : ''}`;

        const body = JSON.stringify(buildRequestBody());

        fetch(url, { body, method: 'POST', headers, signal: abortController.signal })
            .then(handleTableResponse)
            .then((json) => {
                setIsModal(false)
                setCurrentRule(null)
            })
            .catch(handleRequestError)
            .finally(() => {
                setLoading(false)
            })
    };

    const isFormValid = () => {
        const isNameValid = name?.trim();
        const isMarketplaceValid = selectedMarketplace?.value;
        const isApiValid = selectedApi?.length > 0;
        const isDecisionValid = selectedDecision?.value;

        const validConditions = conditions.filter(
            cond => cond?.condition_type && cond?.condition_type !== ''
        );

        if (validConditions.length === 0) return false;

        const areConditionsValid = validConditions.every(cond => {
            if (!cond?.attributes || cond?.attributes?.length === 0) {
                return true;
            }

            return cond?.attributes?.every(field => {
                if (field?.required) {
                    return field?.value !== null &&
                        field?.value !== undefined &&
                        field?.value !== '';
                }
                return true;
            });
        });

        // Валидация полей окна активации только если чекбокс активен
        let areMainFieldsValid = true;
        if (showActivationWindow && mainFields && mainFields.length > 0) {
            const hasFilledFields = mainFields.some(field => 
                field?.value !== null && field?.value !== undefined && field?.value !== ''
            );
            if (hasFilledFields) {
                areMainFieldsValid = mainFields?.every(field => {
                    if (field?.required) {
                        return field?.value !== null &&
                            field?.value !== undefined &&
                            field?.value !== '';
                    }
                    return true;
                });
            }
        }

        return isNameValid &&
            isMarketplaceValid &&
            isApiValid &&
            isDecisionValid &&
            areMainFieldsValid &&
            areConditionsValid;
    };

    if (conditionsLoading) {
        return (
            <div className={'blackout'}>
                <div className='modal-returns-rule'>
                    <div style={{ display: 'flex', justifyContent: 'center', padding: '40px' }}>
                        <MoonLoader color="#00B45E" size={40} />
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className={'blackout'} onClick={(e) => {
            let el = e.target
            if (el.classList.contains('blackout')) {
                setIsModal(false)
                setCurrentRule(null)
            }
        }}>
            <div className='modal-returns-rule'>
                <header className='modal-returns-rule__header'>
                    <TitlePage
                        title={!currentRule ? 'Создать правило' :
                            <>Редактировать правило<span style={{ color: '#00B45E' }}> ID-{currentRule?.id}</span></>}
                    />

                    {(currentRule?.created_at || currentRule?.updated_at) && <div className='modal-returns-rule__date-info'>
                        {currentRule?.created_at && <span>Создано {dayjs(currentRule?.created_at).format('DD-MM-YY')}</span>}
                        {currentRule?.updated_at && <span>Обновлено {dayjs(currentRule?.updated_at).format('DD-MM-YY')}</span>}
                    </div>}

                    <CheckboxToggle
                        text='Активно'
                        value={isActive}
                        onChange={(e) => setIsActive(!isActive)}
                    />

                    <ButtonClose
                        onClick={(e) => {
                            setIsModal(false)
                            setCurrentRule(null)
                        }}
                    />
                </header>

                <div className='modal-returns-rule__content'>
                    {!currentRule && <StepItem
                        title={<>Заполните необходимые параметры</>}
                        description={
                            <>
                                <span style={{ color: 'red' }}>
                                    {' '}
                                    Красными звездочками
                                </span>{' '}
                                выделены обязательные пункты для заполнения</>}
                    />}

                    <InputDinamycPlaceholder
                        onChange={setName}
                        placeholder='Название правила'
                        changeValue={name}
                        size='s'
                        required
                        maxWidth={'432px'}
                    />

                    <DateBox
                        startDate={date}
                        setStartDate={setDate}
                        size='s'
                    />

                    <div className="modal-returns-rule__select-group">
                        <DropDownSelector
                            required={true}
                            state={selectedMarketplace}
                            options_prop={options_prop_mp}
                            total={options_prop_mp?.length}
                            setState={setSelectedMarketplace}
                            placeholder="Площадка"
                            disabled={currentRule}
                            onBlur={() => {
                                setSelectedDecision(null)
                                setDecisionData(null)
                                apiFilter()
                            }}
                        />

                        <DropDownSelector
                            state={selectedApi}
                            options_prop={apiData}
                            total={totalApi}
                            setState={setSelectedApi}
                            placeholder="Магазин"
                            fetchCallback={setApiPage}
                            setInputChange={setApiQuery}
                            multi
                            required={true}
                        />
                    </div>

                    <TitlePage
                        medium
                        title='Условия'
                    />

                    <div className='modal-returns-rule__double-content'>
                        {conditions.map((condition, index) => (
                            <ConditionItem
                                key={index}
                                condition={condition}
                                index={index}
                                currentConditions={currentConditions}
                                selectedApi={selectedApi}
                                onConditionChange={handleConditionChange}
                                onRemove={handleRemoveCondition}
                                canRemove={conditions.length > 1}
                            />
                        ))}
                    </div>

                    <ButtonBasic
                        text='Добавить условие'
                        onClick={handleAddCondition}
                        size='small'
                        blue
                        style={{ minHeight: '40px' }}
                    />

                    <div className='modal-returns-rule__double-content'>
                        <div className='modal-returns-rule__content-item'>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
                                <CheckboxToggle
                                    text='Окно активации'
                                    value={showActivationWindow}
                                    onChange={() => {
                                        setShowActivationWindow(!showActivationWindow);
                                        // Если выключаем чекбокс, сбрасываем значения полей
                                        if (showActivationWindow) {
                                            setMainFields(prev => prev.map(field => ({
                                                ...field,
                                                value: null
                                            })));
                                        }
                                    }}
                                />
                            </div>

                            {showActivationWindow && (
                                <DynamicFormComponent
                                    api_id={selectedApi?.map(el => el?.value) || []}
                                    productTemporary={mainFields}
                                    setProductTemporary={setMainFields}
                                />
                            )}
                        </div>

                        <div className='modal-returns-rule__content-item'>
                            <TitlePage
                                medium
                                title='Доступные решения'
                            />

                            <DecisionSelector
                                state={selectedDecision}
                                setState={setSelectedDecision}
                                placeholder="Выберите решение"
                                required={true}
                                mpId={selectedMarketplace?.value}
                                onDecisionChange={handleDecisionChange}
                                currentRule={currentRule}
                            />
                        </div>
                    </div>
                </div>

                <div className='modal-returns-rule__btn'>
                    <ButtonBasic
                        text={currentRule ? 'Редактировать правило' : 'Создать правило'}
                        green
                        onClick={fetchCreateRule}
                        size='56px'
                        disabled={!isFormValid()}
                    />
                </div>
            </div>
        </div>
    )
}

export { ModalReturnsRule }